import { checkTextSafe } from '@/api/global'
import { use$to } from '@/utils/useUtils'

/**
 * 检查内容是否安全
 * @param {string} content - 需要检查的内容
 * @param {Function} loadingCallback - 加载状态回调函数
 * @returns {Promise<boolean>} - 返回内容是否安全
 */
export const checkContentSafety = async (content, loadingCallback) => {
  if (typeof loadingCallback === 'function') {
    loadingCallback(true)
  }

  const $to = use$to()
  const [err, res] = await $to(checkTextSafe({
    content,
  }))

  if (typeof loadingCallback === 'function') {
    loadingCallback(false)
  }

  if (err || res?.code !== 1) return false
  const { suggestion = 'block' } = res?.data
  if (suggestion === 'block') {
    return false
  }
  return true
}
